/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFashionDesignWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFashionDesignWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Design Together!",
    "Fashion Design Awaits!",
    "Create Your Own Style!",
  ],
  title: "Fashion Design Workshop",
  description: "Organize a creative fashion design workshop.",
  longDescription:
    "Gather your friends for a fashion design workshop! Choose a date, decide on styles to explore, and plan activities for the session!",
  emoji: "👗",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Fashion Design Workshop",
          emoji: "👗",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the fashion design workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on styles to explore?",
            description: "What styles should we focus on during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What styles should we consider?",
                emoji: "🎨",
                completeAction: {
                  question: "Decide on materials needed?",
                  description:
                    "What materials should we gather for the designs?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What materials should we bring?",
                      emoji: "🧵",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Create Fashion!",
    outroDescription:
      "Your fashion design workshop plans are set! Enjoy the creativity!",
  },
};
